import { deepCompare } from "@website/utils/deep-compare";
import { ReserveCommentsFilterItem } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter-item";
import { ReserveCommentFilterTypes } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter.types";
import { ReserveCommentsSort } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-sort/reserve-comment-sort";
import isEmpty from "lodash-es/isEmpty";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = ({
  onLoadFilter,
  filters,
  isInsideDetail
}: ReserveCommentFilterTypes) => {
  const router = useRouter();
  return (
    // const filterCount = Object.keys(router?.query).filter((item) =>
    //   item.startsWith("filter_")
    // ).length;
    <div className="flex flex-row items-center justify-between gap-4">
      {!isEmpty(filters) && (
        <ReserveCommentsFilterItem
          filterName={{
            fa: `${
              router?.query?.["filter_attitude"] === "all"
                ? "همه نظرات"
                : router?.query?.["filter_attitude"] === "positive"
                  ? "نظرات مثبت"
                  : router?.query?.["filter_attitude"] === "negative"
                    ? "نظرات منفی"
                    : "نوع نظرات"
            }`,
            en: `${Object.keys(filters)[0]}`
          }}
          isInsideDetail={isInsideDetail}
          onLoadFilter={onLoadFilter}
          radioItems={[
            { label: "همه نظرات", value: "all" },
            { label: "نظرات مثبت", value: "positive" },
            { label: "نظرات منفی", value: "negative" }
          ]}
          startIconName="stars"
        />
      )}
      <ReserveCommentsSort
        filterName={{
          fa: `${
            router?.query?.["order_by"] === "recommended"
              ? "پیشنهادی"
              : router?.query?.["order_by"] === "newest"
                ? "جدیدترین"
                : "مرتب‌سازی"
          }`,
          en: ``
        }}
        isInsideDetail={isInsideDetail}
        onLoadFilter={onLoadFilter}
        radioItems={[
          { label: "پیشنهادی", value: "recommended" },
          { label: "جدیدترین", value: "newest" }
        ]}
        startIconName="sort"
      />
      {/*{Boolean(filterCount) && (*/}
      {/*  <Button*/}
      {/*    color="secondary"*/}
      {/*    onClick={() => {*/}
      {/*      if (onLoadFilter) {*/}
      {/*        onLoadFilter({ attitude: "all" });*/}
      {/*      }*/}
      {/*      router.push(*/}
      {/*        {*/}
      {/*          pathname: router.pathname,*/}
      {/*          query: {*/}
      {/*            ...omit(*/}
      {/*              router?.query,*/}
      {/*              Object.keys(router?.query).filter((item) =>*/}
      {/*                item.startsWith("filter_")*/}
      {/*              )*/}
      {/*            )*/}
      {/*          }*/}
      {/*        },*/}
      {/*        undefined,*/}
      {/*        { shallow: true, scroll: false }*/}
      {/*      );*/}
      {/*    }}*/}
      {/*    size="small"*/}
      {/*    variant="text"*/}
      {/*  >*/}
      {/*    {` حذف فیلتر ها (${numberConvert(filterCount, {*/}
      {/*      locale: router.locale*/}
      {/*    })}) `}*/}
      {/*  </Button>*/}
      {/*)}*/}
    </div>
  );
};
export const ReserveCommentsFilter = memo(Component, deepCompare);
